/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_9_DescriptionInputs */

const en_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step onto candy-dotted golden-orange ground and set off on a whimsical forest adventure with the little bones.`)
};

const ar_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اخطُ على أرض بلون برتقالي ذهبي تتناثر عليها الحلوى، وانطلق في مغامرة خيالية في الغابة برفقة العظام الصغيرة.`)
};

const de_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betritt den goldorangen, mit Bonbons übersäten Boden und erlebe mit den kleinen Knochen ein fantasievolles Waldabenteuer.`)
};

const es_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pisa el suelo anaranjado y dorado salpicado de caramelos y emprende una fantástica aventura en el bosque junto a los huesecillos.`)
};

const fr_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foulez un sol orangé aux reflets dorés parsemé de bonbons et partez pour une aventure féerique dans la forêt en compagnie de petits os.`)
};

const it_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cammina su un terreno arancione dorato cosparso di caramelle e parti per una fantasiosa avventura nella foresta insieme agli ossicini.`)
};

const ja_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンディが散りばめられたオレンジがかった黄金色の大地を踏みしめ、小さな骨たちとマイフォレストで不思議な冒険に出かけよう。`)
};

const ko_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알록달록한 사탕이 흩어진 황금빛 주황색 땅을 밟으며, 작은 뼈들과 함께 나의 숲에서 신비로운 모험을 떠나 보세요.`)
};

const pt_br_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pise no chão laranja-dourado salpicado de doces e embarque em uma aventura encantada na floresta com os ossinhos.`)
};

const ru_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ступите на золотисто-оранжевую землю, усыпанную конфетами, и отправьтесь в сказочное лесное приключение вместе с маленькими косточками.`)
};

const th_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก้าวลงบนพื้นสีส้มทองที่แต่งแต้มด้วยลูกอม แล้วออกผจญภัยสุดพิศวงในป่าไปกับกระดูกชิ้นน้อย`)
};

const tr_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şekerlerle bezeli altın turuncusu zemine adım at ve minik kemiklerle masalsı bir orman macerasına çık.`)
};

const zh_cn_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`踩着糖果缤纷的金橙地面，与森林里的小骨头展开一场森林奇遇。`)
};

const zh_tw_landskin_9_description = /** @type {(inputs: Landskin_9_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`踩著糖果繽紛的金橙地面，與森林裡的小骨頭展開一場森林奇遇。`)
};

/**
* | output |
* | --- |
* | "Step onto candy-dotted golden-orange ground and set off on a whimsical forest adventure with the little bones." |
*
* @param {Landskin_9_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_9_description = /** @type {((inputs?: Landskin_9_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_9_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_9_description(inputs)
	if (locale === "ar") return ar_landskin_9_description(inputs)
	if (locale === "de") return de_landskin_9_description(inputs)
	if (locale === "es") return es_landskin_9_description(inputs)
	if (locale === "fr") return fr_landskin_9_description(inputs)
	if (locale === "it") return it_landskin_9_description(inputs)
	if (locale === "ja") return ja_landskin_9_description(inputs)
	if (locale === "ko") return ko_landskin_9_description(inputs)
	if (locale === "pt_br") return pt_br_landskin_9_description(inputs)
	if (locale === "ru") return ru_landskin_9_description(inputs)
	if (locale === "th") return th_landskin_9_description(inputs)
	if (locale === "tr") return tr_landskin_9_description(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_9_description(inputs)
	return zh_tw_landskin_9_description(inputs)
});